import { forwardRef } from 'react';

export const SellingHorizon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="0 0 113.4 113.4"
        ref={ref}
        xmlSpace="preserve"
        {...props}
      >
        <style>
          {
            '.st0{fill:none;stroke:#004b54;stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}'
          }
        </style>
        <path className="st0" d="m42.6 30.7-27 19.7v40.4h53.9V75.2" />
        <path
          className="st0"
          d="M49.5 90.8V68c0-.6-.5-1.2-1-1.2H36.2c-.6 0-1 .5-1 1.2v22.8h14.3zM42.6 30.7l10.5 7.7M42.6 30.7l-34.1 25M82.2 28.6l.1 16.7M94.1 45.2l-11.6.1M63.6 45.3h3.5M82.2 63.9v-3.5M67.1 45.3h-3.5M95.4 58.4 92.9 56M71.5 56l-2.4 2.4M69.1 32.1l2.4 2.5"
        />
        <circle className="st0" cx={82} cy={45.5} r={22.9} />
        <path className="st0" d="m71.5 56-2.4 2.4" />
      </svg>
    );
  },
);
